import Modal from '../../../../../components/modal'
import { Button } from '../../../../../components/button'

export default function NoticeAboutConciergeModal({ onAccept, onClose }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <p className='description'>
          Please note that as the seller you are responsible for ensuring your vehicle is taken to
          one of our concierge locations, but don't worry we'll help you with that!
        </p>
        <div className='buttonsContainer flex alignCenter justifyCenter'>
          <Button onClick={onAccept}>Accept</Button>
          <Button onClick={onClose} color='secondary'>
            Decline
          </Button>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          max-width: 100vw;
          width: 70rem;
          padding: 1.8rem 2rem 0.8rem;
          background: #fff;
          border-radius: 1rem;

          p {
            max-width: 60rem;
            width: 100%;
            margin: 1.3rem auto 0;
            text-align: center;
            font-size: 1.6rem;
          }
        }

        .buttonsContainer {
          :global(button) {
            margin: 2rem 0.35rem;
          }
        }
      `}</style>
    </Modal>
  )
}
